<template>
  <div class="footer">
    <div class="footer-border">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
    <div class="container">
      <a @click="$router.push('/')">
        <img v-if="!mme" src="@/assets/logo.png" width="117" height="35" />
        <img v-else src="https://ligneetlumiere.fr/wp-content/uploads/2020/07/ligne-lumiere-logo1.png" />
      </a>
      <div class="content">
        <div class="line">
          <img src="@/assets/footer-map-marker.png" width="30" height="30" />
          <div>
            Rue Diane Fossey - ZAC EcoParc
            <br />
            CS 30842 - 57140 Norroy-le-Veneur
          </div>
        </div>
        <div class="line">
          <img src="@/assets/footer-phone.png" width="30" height="30" />
          <div>
            Tél : +33 (0)3 87 70 70 70
            <br />
            Fax : +33 (0)3 87 70 70 87
          </div>
        </div>
      </div>
      <div class="content">
        {{new Date().getFullYear()}}© Copyright by CMEM
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Footer",
    props: { mme: Boolean }
  }
</script>

<style scoped>
  .footer {
    height: 160px;
    margin-top: 60px;
    background-color: #333;
    color: white;
    box-sizing: border-box;
    position: relative;

    padding-top: 30px;

    justify-content: space-around;
  }

  .footer .container {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    /*width: 1140px;*/
    max-width: 1140px;
    margin: 0 auto;
  }

  .footer .container img {
      max-height: 120px;
  }

  .footer .content {
    display: flex;
    flex-direction: column;
    row-gap: 15px;
  }

  .footer .content .line {
    display: flex;
    flex-direction: row;
    align-items: center;
    column-gap: 15px;
  }

  .footer-border {
    display: grid;
    grid-template-columns: repeat(8, 1fr);
    height: 6px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
  }

    .footer-border div:nth-child(1) {
      background-color: #48373a;
    }
    .footer-border div:nth-child(2) {
      background-color: #71845d;
    }
    .footer-border div:nth-child(3) {
      background-color: #8db151;
    }
    .footer-border div:nth-child(4) {
      background-color: #0fa89e;
    }
    .footer-border div:nth-child(5) {
      background-color: #276e94;
    }
    .footer-border div:nth-child(6) {
      background-color: #234152;
    }
    .footer-border div:nth-child(7) {
      background-color: #5f4065;
    }
    .footer-border div:nth-child(8) {
      background-color: #f1694b;
    }

</style>



// WEBPACK FOOTER //
// src/components/Footer.vue